import type { FaireProductEntity } from "../../entity_types/product";

export const p_4zm9prvucn: FaireProductEntity = {
  token: "p_4zm9prvucn",
  type: "product",
  name: "Organs Blend Once Daily | Tablets (30 Tablets)",
  brandToken: "b_at5l4qlr",
  brandName: "Ancient Nutrition",
  imageUrl:
    "https://cdn.faire.com/fastly/7b152e5df6958ec65b3f1fe89ca655e53b21def0456dc42cb5fe4f976c9ab11b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3896c7772b787fa3fc42c97ea542be41f520364e20f3565de7d5aad9a277fdde.jpeg",
    "https://cdn.faire.com/fastly/f03e87742fb7697829a444d485de32e7fbad0d4d67d35010e6f92cee7a9dec55.jpeg",
    "https://cdn.faire.com/fastly/eacc7956169d00acb3f50350bc224d2bfb0c5af3362c899ed548813c5eed2735.jpeg",
    "https://cdn.faire.com/fastly/d3820f59d5c5669d44868504a7e048d285c068a23bccd42d8d177b23d11b2587.jpeg",
    "https://cdn.faire.com/fastly/eb5f6618cd05da8d7d01e9d822f4106387455fb9f18baa25476140dc5c839576.jpeg",
    "https://cdn.faire.com/fastly/c64259dbd8ebda560c289730c409b96f4f076c9ba161ffb9afbddc2d7a17b5e6.jpeg",
    "https://cdn.faire.com/fastly/dd046dcaa3dac75668ab2312a3e3b0cf2a4883da39bfdb3434e39aacf84d8cc0.jpeg",
  ],
  priceDollars: 17.97,
  description:
    "This wild, grass-fed organ blend packs the benefits of ancient superfoods into a single daily tablet to help promote organ health and wellbeing.†\n",
  tags: [],
  msrpDollars: 24.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:25:56.393Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
